import { select, observe, parseDuration } from './_util.js';

/**
 * Animate an image using the slide up color wash
 *
 * @param {String|Array|NodeList|HTMLElement} selector
 * @param {object} opts
 * @returns {Array}
 */
export function scale( selector, opts = {} ) {
	opts = {
		delay: 1,
		duration: null,
		...opts
	}

	return select( selector ).forEach( ( node ) => {
		node.classList.add( 'animated-scale' );

		if ( opts.duration ) {
			node.style.animationDuration = parseDuration( opts.duration );
		}

		observe( node ).then( () => setTimeout( () => node.classList.add( 'animated-scale--active' ), opts.delay ) );
	} );
}
